import script from "./ArticlesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArticlesView.vue?vue&type=script&lang=ts&setup=true"

import "./ArticlesView.vue?vue&type=style&index=0&id=b957a0ec&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b957a0ec"]])

export default __exports__